import "/data/landun/workspace/codebase/node_modules/core-js/modules/es.array.iterator.js";
import "/data/landun/workspace/codebase/node_modules/core-js/modules/es.promise.js";
import "/data/landun/workspace/codebase/node_modules/core-js/modules/es.object.assign.js";
import "/data/landun/workspace/codebase/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store';
import eventBus from './util/eventBus';
import envCheck from './util/envCheck';
import '@/plugins';
import '@/mixin';
import '@/mixin/level';
Vue.config.productionTip = false;
Vue.prototype.setting = window.setting;
Vue.prototype.eventBus = eventBus;
var _window$setting$ = window.setting.环境兼容,
    pad链接 = _window$setting$.pad链接,
    pc链接 = _window$setting$.pc链接,
    pad图 = _window$setting$.pad图;
envCheck({
  padUrl: pad链接,
  pcUrl: pc链接,
  padPic: pad图
}, function () {
  new Vue({
    store: store,
    render: function render(h) {
      return h(App);
    }
  }).$mount('#app');
});